import styled from 'styled-components';
import { PrimaryButtonComponent } from '../../../../../../CommonComponents/commonStyles.js'

export const DisplayContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const SectionHeading = styled.div`
  font-family: ${props => props.theme.fontFamily.BerkeleyStdBold};
  font-size: ${props => props.theme.fontSize.h4};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h4};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.headingColor};
`

export const SectionContent = styled.div`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.primary};
font-style: normal;
font-stretch: ${props => props.theme.fontStretch.normal};
line-height: ${props => props.theme.lineHeight.primary};
letter-spacing: ${props => props.theme.letterSpacing.zero};
text-align: center;
color: ${props => props.theme.fontColors.textColor};
padding-bottom:1.875rem;
`

export const LoadMoreButton = styled(PrimaryButtonComponent)`
  margin:30px auto;
  width:300px;
  @media only screen and (max-width: 991px) {
    font-size:${props => props.theme.fontSize.primary};
  }
`

export const EndResult = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.secondary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.secondary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.thead};
  padding-top: 3.125rem;
`;

export const BtnWrapper = styled.div`
>button{
  margin: 30px auto;
  width: 300px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width:100%;
  }
}
  
`